import { render } from "./beautyVideos.vue?vue&type=template&id=1b5fbbfa&scoped=true"
import script from "./beautyVideos.vue?vue&type=script&lang=js"
export * from "./beautyVideos.vue?vue&type=script&lang=js"

import "./beautyVideos.vue?vue&type=style&index=0&id=1b5fbbfa&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5fbbfa"]])

export default __exports__